module.exports = __webpack_public_path__ + "img/QUITTING BEFORE POSTING-en.f832894.png";